<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] {{ $t('period_History') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)"
                            v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div v-if="header && this.Error_Message && this.submitted">
                        <Message severity="warn" :closable="false">
                            {{ this.Error_Message }}
                        </Message>
                    </div>
                    <TabView>
                        <TabPanel>
                            <template #header>Main Data</template>
                            <div class="grid">
                                <div class="col-6">
                                    <div class="field grid">
                                        <label for="Year" class="col-4">{{ $t('year') }}<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <Dropdown v-model="header.Year" v-if="header" :options="years"
                                                optionLabel="value" optionValue="value" :placeholder="$t('year')"
                                                :disabled="mode != this.$FORM_MODE_CREATE"
                                                :class="{ 'p-invalid': submitted && !header.Year }" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Year && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{
                                                $t('is_required').replace('Value', $t('year')) }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Semester" class="col-4">{{ $t('semester') }}<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <InputText name="Semester" v-model="header.Semester" required="true"
                                                type="text" :placeholder="$t('semester')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Semester }"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Semester && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('semester')) }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Cut_Off" class="col-4">{{ $t('cut_off') }}<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <DatePicker tabindex="3" name="Cut_Off" v-model="header.Cut_Off"
                                                :showOnFocus="true" :placeholder="$t('cut_off')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Cut_Off }" :disabled="mode != this.$FORM_MODE_CREATE &&
                                mode != this.$FORM_MODE_EDIT" dateFormat="dd/mm/yyyy" :minDate="minDate"
                                                :maxDate="maxDate" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                                style="width : 100%" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Cut_Off && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('cut_off')) }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Valid_From" class="col-4">{{ $t('valid_from') }} (User)<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <DatePicker tabindex="3" name="Valid_From" v-model="header.Valid_From"
                                                :showOnFocus="true" :placeholder="$t('valid_from')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Valid_From }" :disabled="mode != this.$FORM_MODE_CREATE &&
                                mode != this.$FORM_MODE_EDIT" dateFormat="dd/mm/yyyy" :minDate="minDate"
                                                :maxDate="maxDate" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                                style="width : 100%" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Valid_From && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('valid_from'))
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Valid_To" class="col-4">{{ $t('valid_to') }} (User)<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <DatePicker tabindex="3" name="Valid_To" v-model="header.Valid_To"
                                                :showOnFocus="true" :placeholder="$t('valid_to')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Valid_To }" :disabled="mode != this.$FORM_MODE_CREATE &&
                                mode != this.$FORM_MODE_EDIT" dateFormat="dd/mm/yyyy" :minDate="minDate"
                                                :maxDate="maxDate" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                                style="width : 100%" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Valid_To && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('valid_to')) }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Valid_From_Admin" class="col-4">{{ $t('valid_from') }} (Admin
                                            Unit)<span style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <DatePicker tabindex="3" name="Valid_From_Admin"
                                                v-model="header.Valid_From_Admin" :showOnFocus="true"
                                                :placeholder="$t('valid_from')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Valid_From_Admin }"
                                                :disabled="mode != this.$FORM_MODE_CREATE &&
                                mode != this.$FORM_MODE_EDIT" dateFormat="dd/mm/yyyy" :minDate="minDate"
                                                :maxDate="maxDate" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                                style="width : 100%" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Valid_From_Admin && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('valid_from'))
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Valid_To_Admin" class="col-4">{{ $t('valid_to') }} (Admin Unit)<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <DatePicker tabindex="3" name="Valid_To_Admin"
                                                v-model="header.Valid_To_Admin" :showOnFocus="true"
                                                :placeholder="$t('valid_to')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Valid_To_Admin }" :disabled="mode != this.$FORM_MODE_CREATE &&
                                mode != this.$FORM_MODE_EDIT" dateFormat="dd/mm/yyyy" :minDate="minDate"
                                                :maxDate="maxDate" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                                style="width : 100%" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Valid_To_Admin && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('valid_to')) }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Effective_Date" class="col-4">{{ $t('effective_date') }}<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <DatePicker tabindex="3" name="Effective_Date" v-model="header.Effective_Date"
                                                :showOnFocus="true" :placeholder="$t('effective_date')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Effective_Date }" :disabled="mode != this.$FORM_MODE_CREATE &&
                                mode != this.$FORM_MODE_EDIT" dateFormat="dd/mm/yyyy" :minDate="minDate"
                                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY" style="width : 100%" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Effective_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('effective_date')) }}
                                            </small>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <template #header>Exclusion</template>
                            <div class="grid">
                                <div class="col-6">
                                    <Message severity="warn" v-html="this.messageError">
                                    </Message>
                                </div>
                                <div class="col-3">
                                    <CustomFileUpload :multiple="false" :showUploadButton="false"
                                        :showCancelButton="false" :customUpload="false" @select="onFileSelect"
                                        ref="attachment" mode="basic" />
                                </div>
                                <div class="col-2">
                                    <Button label="Tampilkan Data" icon="pi pi-eye"
                                        class="p-button p-component p-button-rounded p-button-success mr-2 mb-2"
                                        @click="showFile()" @select="onFileSelect" />
                                </div>
                                <div class="col-1">
                                    <Button type="button" class="p-button-warning p-button-rounded p-button-sm"
                                        label="Export" icon="pi pi-file-excel" @click="onExport()" />
                                </div>
                                <div class="col-12">
                                    <DataTable v-if="header" :loading="!header"
                                        :value="header.Details ? header.Details : null" responsiveLayout="scroll"
                                        class="p-datatable-sm editable-cells-table">
                                        <Column :exportable="false" style="width:30px">
                                            <template #header>
                                                <Button label="" icon="pi pi-plus"
                                                    class="p-button-primary p-mr-2 p-button-sm" @click="addDetail()"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                            </template>
                                            <template #body="slotProps">
                                                <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                    @click="deleteDetail(slotProps)"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                    :class="{ 'row-hidden': slotProps.data.mode == this.$FORM_MODE_DELETE }"
                                                    v-show="slotProps.data.mode != 'Delete'" />
                                            </template>
                                        </Column>
                                        <Column field="NIK" :header="$t('userExc')" key="NIK">
                                            <template #body="slotProps">
                                                <div class="p-fluid">
                                                    <CustomSelect class="p-inputtext-sm" :filter="true"
                                                        v-model="slotProps.data[slotProps.column.props.field]"
                                                        :url="this.$API_URL + 'list/user_code'" :minLength="0"
                                                        :params="{}"
                                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                        :class="{ 'row-hidden': slotProps.data.mode == this.$FORM_MODE_DELETE }"
                                                        @change="onCellEditComplete(slotProps); onChangeUser(slotProps, $event)" />
                                                </div>
                                            </template>
                                        </Column>
                                        <Column field="Name" header="Name" key="Name" v-if="false">
                                            <template #body="slotProps">
                                                <div class="p-fluid">
                                                    <InputText name="Name" type="text"
                                                        v-model="slotProps.data[slotProps.column.props.field]" />
                                                </div>
                                            </template>
                                        </Column>
                                        <Column field="Valid_From" :header="$t('valid_from')" key="Valid_From">
                                            <template #body="slotProps">
                                                <div class="p-fluid">
                                                    <DatePicker name="Valid_From"
                                                        v-model="slotProps.data[slotProps.column.props.field]"
                                                        :placeholder="$t('valid_from')"
                                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                        :class="{ 'row-hidden': slotProps.data.mode == this.$FORM_MODE_DELETE }"
                                                        @change="onCellEditComplete(slotProps)" dateFormat="dd/mm/yyyy"
                                                        :minDate="minDate" :maxDate="maxDate" inputMask="99/99/9999"
                                                        momentFormat="DD/MM/YYYY" style="width : 100%" />
                                                </div>
                                            </template>
                                        </Column>
                                        <Column field="Valid_To" :header="$t('valid_to')" key="Valid_To">
                                            <template #body="slotProps">
                                                <div class="p-fluid">
                                                    <DatePicker name="Valid_To"
                                                        v-model="slotProps.data[slotProps.column.props.field]"
                                                        :placeholder="$t('valid_to')"
                                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                        :class="{ 'row-hidden': slotProps.data.mode == this.$FORM_MODE_DELETE }"
                                                        @change="onCellEditComplete(slotProps)" dateFormat="dd/mm/yyyy"
                                                        :minDate="minDate" :maxDate="maxDate" inputMask="99/99/9999"
                                                        momentFormat="DD/MM/YYYY" style="width : 100%" />
                                                </div>
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <template #header>Filter Transaction</template>
                            <div class="grid">
                                <div class="col-12">
                                    <DataTable v-if="header" :loading="!header"
                                        :value="header.Filters ? header.Filters : null" responsiveLayout="scroll"
                                        class="p-datatable-sm editable-cells-table">
                                        <Column :exportable="false" style="width:30px">
                                            <template #header>
                                                <Button label="" icon="pi pi-plus"
                                                    class="p-button-primary p-mr-2 p-button-sm" @click="addFilter()"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                            </template>
                                            <template #body="slotProps">
                                                <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                    @click="deleteFilter(slotProps)"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                    :class="{ 'row-hidden': slotProps.data.mode == this.$FORM_MODE_DELETE }"
                                                    v-show="slotProps.data.mode != 'Delete'" />
                                            </template>
                                        </Column>
                                        <Column field="Menu_Id" :header="$t('trans_menu')" key="Menu_Id"
                                            style="width:300px">
                                            <template #body="slotProps">
                                                <div class="p-fluid">
                                                    <CustomSelect class="p-inputtext-sm" :filter="true"
                                                        v-model="slotProps.data[slotProps.column.props.field]"
                                                        :url="this.$API_URL + 'list/menu'" :minLength="0"
                                                        :params="{ onlyTransaction: 'true' }"
                                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                        :class="{ 'row-hidden': slotProps.data.mode == this.$FORM_MODE_DELETE }"
                                                        @change="onCellEditFilterComplete(slotProps)" />
                                                </div>
                                            </template>
                                        </Column>
                                        <Column field="Job_Status_Code" :header="$t('jobStatus')" key="Job_Status_Code">
                                            <template #body="slotProps">
                                                <div class="p-fluid">
                                                    <CustomMultiSelect class="p-inputtext-sm"
                                                        v-model="slotProps.data[slotProps.column.props.field]"
                                                        type="text" placeholder="All"
                                                        :url="this.$API_URL + 'list/job_status_code'" :minLength="0"
                                                        :params="{}" :filter="true" :optionValue="'id'"
                                                        :optionLabel="'text'"
                                                        @change="onCellEditFilterComplete(slotProps)"
                                                        :class="{ 'row-hidden': slotProps.data.mode == this.$FORM_MODE_DELETE }"
                                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                                </div>
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
export default {
    name: "Editor",
    data() {
        return {
            indexName: "Period_HistoryIndex",
            url: this.$API_URL + "period_History/",
            header: null,
            detail: null,
            filterDetail: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            podFiles: [],
            messageError: null,
            tempDetail: []
        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    if (response.data.success) {
                        self.header = response.data.data.header;
                        self.header.mode = self.mode;
                        self.detail = response.data.data.detail;
                        self.filterDetail = response.data.data.filterDetail;
                    }
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;

            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "Period_History " + self.header.Year + " has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Period_History " + self.header.Year + " has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/Period_History/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            if (!this.header.Year || !this.header.Semester || !this.header.Cut_Off || !this.header.Valid_From || !this.header.Valid_To) {
                return;
            } else {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {

                    }
                });
            }
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        addFilter() {
            var newFilter = this.filterDetail;
            newFilter.mode = this.$FORM_MODE_CREATE;
            var det = { ...newFilter };
            det.Job_Status_Code = ['01', '02', '04', '05', '06', '07', '08', '09'];

            this.header.Filters.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        deleteFilter(event) {
            if (event) {
                var filterDetail = this.header.Filters[event.index];

                if (filterDetail.mode == this.$FORM_MODE_CREATE) this.header.Filters.splice(this.header.Filters.indexOf(filterDetail), 1);
                else filterDetail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onCellEditFilterComplete(event) {
            this.editFilter(event.index);
        },
        editFilter(index) {
            if (this.header && this.header.Filters) {
                let mode = this.header.Filters[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Filters[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onExport() {
            this.loading = true;
            var self = this;
            let UrlExport = "Period_History/export_exclusion"

            if (!self.header.Details || self.header.Details.length == 0) {
                var newDetail = self.detail;
                newDetail.mode = 'TEMPLATE ONLY';
                var det = { ...newDetail };

                self.tempDetail = [];
                self.tempDetail.push(det);                
            }

            this.$axios.post(self.$API_URL + UrlExport, !self.header.Details ? self.tempDetail : self.header.Details, {
                responseType: 'blob'
            })
                .then((response) => {
                    var contentDisposition = response.headers["content-disposition"];
                    var matchName = contentDisposition.match(/filename\s*=\s*"?(.+)"?/);
                    var filename = matchName[1].split(';')[0];

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();

                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: self.$DEFAULT_TIMER });
                    self.loading = false;
                });

            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
        onChangeUser(slotProps, event) {
            slotProps.data.Name = event.Full_Name;
        },
        onFileSelect(event) {
            this.podFiles = event.files;
        },
        showFile() {
            let UrlShowFile = "Period_History/upload_exclusion"
            this.messageError = null;

            var self = this;
            if (this.podFiles.length == 0)
                this.showError('Error Upload Data', "Must have at least one file");
            else {
                this.$emit('block-ui');
                var self = this;
                var data = new FormData();

                for (var i = 0; i < this.podFiles.length; i++) {
                    data.append("file", this.podFiles[i], this.podFiles[i].name);
                }

                data.append("Period_History_Id", JSON.stringify(self.header.Id));

                this.$axios.put(this.$API_URL + UrlShowFile, data,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        timeout: 7000000
                    }).then((response) => {
                        if (response.data.success) {
                            this.$emit('unblock-ui');
                            self.detail = response.data.data;
                            self.header.Details = response.data.data;
                        }
                        else {
                            this.$emit('unblock-ui');
                            this.messageError = response.data.message;
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });

                self.podFiles = [];
                self.$refs.attachment.clear();
            }
        }
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    },
    computed: {
        years() {
            let years = [];

            for (var i = new Date().getFullYear(); i <= new Date().getFullYear() + 20; i++) {
                years.push({ value: i.toString() })
            }
            return years;
        },
        minDate() {
            let today = new Date();
            let year = today.getFullYear().toString();

            if (this.header.Year) {
                return new Date(this.header.Year.toString() + '-01-01');
            }
            else
                return new Date(year + '-01-01');
        },
        maxDate() {
            let today = new Date();
            let year = today.getFullYear();

            if (this.header.Year) {
                return new Date(this.header.Year.toString() + '-12-31');
            }
            else
                return new Date(year + '-12-31');
        }
    }
}
</script>